import React, {useContext} from "react"
import {gaCategories, gaEvents} from "../../../config/googleAnalytics/events"
import Typography from "../../reusable/Typography/Typography"
import Image from "next/image"
import AnalyticsContext from "../../../context/AnalyticsContext"
import useBookShowroom from "../../../hooks/useBookShowroom"
import {useTranslation} from "next-i18next"

type Props = {
  bikeName?: string;
};

const BookTestDrive: React.FC<Props> = ({bikeName}) => {
	const openShowroomBookingModal = useBookShowroom()
	const {reactGA} = useContext(AnalyticsContext)
	const {t} = useTranslation()

	const handleClick = () => {
		reactGA?.event({
			categories: gaCategories.testDrive,
			action: gaEvents.testDriveCTA,
			label: `Test Drive for ${bikeName} clicked`,
			nonInteraction: false
		})
		openShowroomBookingModal()
	}

	const IconCircle = ({size}: { size: number }) => (
		<div
			className="d-flex align-items-center justify-content-center"
			style={{
				width: size,
				height: size,
				zIndex: 2,
				backgroundColor: "#FFF6E7",
				borderRadius: "50%"
			}}
		>
			<Image
				src="/assets/icons/test-drive.svg"
				height={size * 0.6}
				width={size * 0.6}
				objectFit="contain"
				alt="Test Drive"
			/>
		</div>
	)

	const ArrowIcon = () => (
		<Image
			src="/assets/icons/arrow-right-golden.svg"
			height={16}
			width={18}
			objectFit="contain"
			alt="Arrow"
		/>
	)

	return (
		<div
			className="col-auto p-3 p-md-4 border cursor-pointer mb-4 mb-md-0 mt-md-5 mb-2"
			style={{borderRadius: 16, maxWidth: 800, width: "100%"}}
			onClick={handleClick}
		>
			{/* Desktop */}
			<div className="d-none d-md-flex justify-content-between gap-2 align-items-center">
				<div className="d-flex gap-3 align-items-center">
					<IconCircle size={56} />
					<div className="d-flex flex-column justify-content-center">
						<Typography variant="bodySmBold"
							semanticTag="h6"
							className="mb-0">
							{t("test-drive-cta")}
						</Typography>
						<Typography variant="bodySm"
							semanticTag="p"
							className="mb-0">
							{t("test-drive-label")}
						</Typography>
					</div>
				</div>
				<ArrowIcon />
			</div>

			{/* Mobile */}
			<div className="d-md-none">
				<div className="d-flex justify-content-between align-items-center mb-3">
					<div className="d-flex gap-3 align-items-center">
						<IconCircle size={40} />
						<Typography variant="bodySmBold"
							semanticTag="h6"
							className="mb-0">
							{t("test-drive-cta")}
						</Typography>
					</div>
					<ArrowIcon />
				</div>
				<Typography variant="bodySm"
					semanticTag="p"
					className="mb-0">
					{t("test-drive-label")}
				</Typography>
			</div>
		</div>
	)
}

export default BookTestDrive
